/*import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../serices/firebase';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { Trophy, Crown, Medal, Zap, TrendingUp, Timer, ArrowRight, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';

const Leaderboard = () => {
  const [nominations, setNominations] = useState([]);
  const [loading, setLoading] = useState(true);

  // 1. Fetch ALL approved nominees in real-time
  useEffect(() => {
    const q = query(collection(db, "nominations"), where("status", "==", "approved"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNominations(data);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // 2. Logic: Group by Category and Sort Top 3
  const getTopThreeByGroup = () => {
    const groups = nominations.reduce((acc, nominee) => {
      const cat = nominee.category || "Uncategorized";
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(nominee);
      return acc;
    }, {});

    // Sort each group by voteCount and take top 3
    const result = Object.keys(groups).map(categoryName => {
      const sorted = groups[categoryName].sort((a, b) => (b.voteCount || 0) - (a.voteCount || 0));
      return {
        category: categoryName,
        topThree: sorted.slice(0, 3),
        totalVotesInCategory: sorted.reduce((sum, p) => sum + (p.voteCount || 0), 0)
      };
    });

    return result;
  };

  const leaderboardData = getTopThreeByGroup();
  const grandTotalVotes = nominations.reduce((acc, curr) => acc + (curr.voteCount || 0), 0);

  if (loading) return <div className="h-screen bg-black flex items-center justify-center"><Loader2 className="animate-spin text-[#D4AF37]" size={48} /></div>;

  return (
    <div className="min-h-screen bg-[#050505] text-white pt-24 pb-20 px-4 md:px-6 font-sans relative overflow-hidden">
      
      {/* Background Decor *//*
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#D4AF37]/5 blur-[120px] rounded-full -z-0" />

      <div className="max-w-7xl mx-auto relative z-10">
        
      
        <header className="text-center mb-24">
  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="inline-flex items-center gap-3 mb-6 bg-white/5 border border-white/10 px-4 py-2 rounded-full">
    <TrendingUp size={16} className="text-[#D4AF37]" />
    <span className="text-[10px] font-black uppercase tracking-[0.4em] text-[#D4AF37]">Live County Momentum</span>
  </motion.div>
  
  <h1 className="text-5xl md:text-8xl font-black uppercase italic tracking-tighter leading-none mb-8">
    THE <span className="text-[#D4AF37]">PULSE</span>
  </h1>

  <div className="flex flex-col md:flex-row justify-center gap-8 md:gap-16 items-center">
    {/* STAT 1: SCALE *//*
    <div className="text-center">
        <p className="text-4xl font-black italic tracking-tighter text-white">
            {nominations.length}+
        </p>
        <p className="text-[9px] font-bold uppercase tracking-widest text-white/30">Total Verified Nominees</p>
    </div>

    {/* VERTICAL DIVIDER *//*
    <div className="h-10 w-px bg-white/10 hidden md:block" />

    {/* STAT 2: TRENDING SCORE (Abstract number to hide revenue) *//*
    <div className="text-center text-[#D4AF37]">
        <p className="text-4xl font-black italic tracking-tighter uppercase">
            High
        </p>
        <p className="text-[9px] font-bold uppercase tracking-widest opacity-50">Current Engagement Level</p>
    </div>

    {/* VERTICAL DIVIDER *//*
    <div className="h-10 w-px bg-white/10 hidden md:block" />

    {/* STAT 3: LOCATION *//*
    {/*<div className="text-center">
        <p className="text-4xl font-black italic tracking-tighter text-white">
            4
        </p>
        <p className="text-[9px] font-bold uppercase tracking-widest text-white/30">Sub-Counties Active</p>
    </div>*//*
  </div>
</header>

        {/* --- CATEGORY RANKINGS GRID --- *//*
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {leaderboardData.map((group, i) => (
            <motion.div 
              key={group.category}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-zinc-900/30 border border-white/5 rounded-[2.5rem] p-8 md:p-10 backdrop-blur-md relative overflow-hidden group hover:border-[#D4AF37]/20 transition-all duration-500"
            >
              {/* Header *//*
              <div className="flex justify-between items-start mb-10">
                <div>
                  <h3 className="text-2xl font-black uppercase italic tracking-tighter text-white group-hover:text-[#D4AF37] transition-colors">{group.category}</h3>
                  <p className="text-[10px] font-bold text-white/30 uppercase tracking-widest mt-1">Top 3 Contenders</p>
                </div>
                <Link to={`/nominees/${group.category}`} className="p-3 bg-white/5 rounded-full hover:bg-[#D4AF37] hover:text-black transition-all">
                  <ArrowRight size={18} />
                </Link>
              </div>

              {/* Podium List *//*
              <div className="space-y-4">
                {group.topThree.map((nominee, idx) => (
                 
                    <div className={`flex items-center justify-between p-4 rounded-2xl border transition-all mb-3 
                        ${idx === 0 ? 'bg-[#D4AF37]/10 border-[#D4AF37]/30' : 'bg-black/40 border-white/5 hover:border-white/20'}`}>
                      
                      <div className="flex items-center gap-4">
                        <div className="relative">
                          <img src={nominee.imageUrl} className="w-12 h-12 rounded-xl object-cover" alt="thumb" />
                          <div className={`absolute -top-2 -left-2 w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-black
                            ${idx === 0 ? 'bg-[#D4AF37] text-black shadow-lg' : 'bg-white/10 text-white'}`}>
                            {idx + 1}
                          </div>
                        </div>
                        <div>
                           <p className="font-black uppercase text-xs tracking-tight flex items-center gap-2">
                             {nominee.name}
                             {idx === 0 && <Crown size={12} className="text-[#D4AF37]" />}
                           </p>
                           {/*<p className="text-[9px] text-white/40 uppercase font-bold tracking-widest">
                             {nominee.voteCount || 0} Votes
                           </p>*//*
                        </div>
                      </div>

                      {/* Vote Progress Line *//*
                      <div className="w-20 hidden sm:block">
                        <div className="h-1 w-full bg-white/5 rounded-full overflow-hidden">
                           <motion.div 
                              initial={{ width: 0 }}
                              animate={{ width: `${(nominee.voteCount / group.topThree[0].voteCount) * 100}%` }}
                              className={`h-full ${idx === 0 ? 'bg-[#D4AF37]' : 'bg-white/40'}`} 
                           />
                        </div>
                      </div>

                      <Zap size={14} className={idx === 0 ? "text-[#D4AF37]" : "text-white/10"} />
                    </div>
                  
                ))}
              </div>

              {/* Total Card Footer *//*
              {/*<div className="mt-8 pt-6 border-t border-white/5 flex justify-between items-center text-[9px] font-black uppercase tracking-[0.2em] text-white/20">
                 <span>Category Volume</span>
                 <span className="text-[#D4AF37]">{group.totalVotesInCategory.toLocaleString()}</span>
              </div>*//*
            </motion.div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Leaderboard;*/





import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../serices/firebase';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { Trophy, Crown, Medal, Zap, TrendingUp, Timer, ArrowRight, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';

const Leaderboard = () => {
  const [nominations, setNominations] = useState([]);
  const [loading, setLoading] = useState(true);

  // 1. Fetch ALL approved nominees in real-time
  useEffect(() => {
    const q = query(collection(db, "nominations"), where("status", "==", "approved"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNominations(data);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // 2. Logic: Group by Category and Sort Top 3
  const getTopThreeByGroup = () => {
    const groups = nominations.reduce((acc, nominee) => {
      const cat = nominee.category || "Uncategorized";
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(nominee);
      return acc;
    }, {});

    // Sort each group by voteCount and take top 3
    const result = Object.keys(groups).map(categoryName => {
      const sorted = groups[categoryName].sort((a, b) => (b.voteCount || 0) - (a.voteCount || 0));
      const totalVotesInCategory = sorted.reduce((sum, p) => sum + (p.voteCount || 0), 0);
      return {
        category: categoryName,
        topThree: sorted.slice(0, 3),
        totalVotesInCategory
      };
    });

    return result;
  };

  // Helper: this nominee's share of votes within their own category, as a whole-number percentage.
  // Kept relative (share of category) rather than absolute counts, matching the abstracted
  // "High Engagement" framing used elsewhere on this page.
  const getVoteShare = (voteCount, totalVotesInCategory) => {
    if (!totalVotesInCategory) return 0;
    return Math.round(((voteCount || 0) / totalVotesInCategory) * 100);
  };

  const leaderboardData = getTopThreeByGroup();
  const grandTotalVotes = nominations.reduce((acc, curr) => acc + (curr.voteCount || 0), 0);

  if (loading) return <div className="h-screen bg-black flex items-center justify-center"><Loader2 className="animate-spin text-[#D4AF37]" size={48} /></div>;

  return (
    <div className="min-h-screen bg-[#050505] text-white pt-24 pb-20 px-4 md:px-6 font-sans relative overflow-hidden">
      
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#D4AF37]/5 blur-[120px] rounded-full -z-0" />

      <div className="max-w-7xl mx-auto relative z-10">
        
        {/* --- HEADER --- */}
        <header className="text-center mb-24">
  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="inline-flex items-center gap-3 mb-6 bg-white/5 border border-white/10 px-4 py-2 rounded-full">
    <TrendingUp size={16} className="text-[#D4AF37]" />
    <span className="text-[10px] font-black uppercase tracking-[0.4em] text-[#D4AF37]">Live County Momentum</span>
  </motion.div>
  
  <h1 className="text-5xl md:text-8xl font-black uppercase italic tracking-tighter leading-none mb-8">
    THE <span className="text-[#D4AF37]">PULSE</span>
  </h1>

  <div className="flex flex-col md:flex-row justify-center gap-8 md:gap-16 items-center">
    {/* STAT 1: SCALE */}
    <div className="text-center">
        <p className="text-4xl font-black italic tracking-tighter text-white">
            {nominations.length}+
        </p>
        <p className="text-[9px] font-bold uppercase tracking-widest text-white/30">Total Verified Nominees</p>
    </div>

    {/* VERTICAL DIVIDER */}
    <div className="h-10 w-px bg-white/10 hidden md:block" />

    {/* STAT 2: TRENDING SCORE (Abstract number to hide revenue) */}
    <div className="text-center text-[#D4AF37]">
        <p className="text-4xl font-black italic tracking-tighter uppercase">
            High
        </p>
        <p className="text-[9px] font-bold uppercase tracking-widest opacity-50">Current Engagement Level</p>
    </div>

    {/* VERTICAL DIVIDER */}
    <div className="h-10 w-px bg-white/10 hidden md:block" />
  </div>
</header>

        {/* --- CATEGORY RANKINGS GRID --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {leaderboardData.map((group, i) => (
            <motion.div 
              key={group.category}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-zinc-900/30 border border-white/5 rounded-[2.5rem] p-8 md:p-10 backdrop-blur-md relative overflow-hidden group hover:border-[#D4AF37]/20 transition-all duration-500"
            >
              {/* Header */}
              <div className="flex justify-between items-start mb-10">
                <div>
                  <h3 className="text-2xl font-black uppercase italic tracking-tighter text-white group-hover:text-[#D4AF37] transition-colors">{group.category}</h3>
                  <p className="text-[10px] font-bold text-white/30 uppercase tracking-widest mt-1">Top 3 Contenders</p>
                </div>
                <Link to={`/nominees/${group.category}`} className="p-3 bg-white/5 rounded-full hover:bg-[#D4AF37] hover:text-black transition-all">
                  <ArrowRight size={18} />
                </Link>
              </div>

              {/* Podium List */}
              <div className="space-y-4">
                {group.topThree.map((nominee, idx) => {
                  const sharePct = getVoteShare(nominee.voteCount, group.totalVotesInCategory);
                  return (
                    <div key={nominee.id} className={`flex items-center justify-between p-4 rounded-2xl border transition-all mb-3 
                        ${idx === 0 ? 'bg-[#D4AF37]/10 border-[#D4AF37]/30' : 'bg-black/40 border-white/5 hover:border-white/20'}`}>
                      
                      <div className="flex items-center gap-4">
                        <div className="relative">
                          <img src={nominee.imageUrl} className="w-12 h-12 rounded-xl object-cover" alt="thumb" />
                          <div className={`absolute -top-2 -left-2 w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-black
                            ${idx === 0 ? 'bg-[#D4AF37] text-black shadow-lg' : 'bg-white/10 text-white'}`}>
                            {idx + 1}
                          </div>
                        </div>
                        <div>
                           <p className="font-black uppercase text-xs tracking-tight flex items-center gap-2">
                             {nominee.name}
                             {idx === 0 && <Crown size={12} className="text-[#D4AF37]" />}
                           </p>
                           <p className="text-[9px] text-white/40 uppercase font-bold tracking-widest mt-1">
                             {sharePct}% of category votes
                           </p>
                        </div>
                      </div>

                      {/* Vote Progress Line (relative to the category leader) */}
                      <div className="w-20 hidden sm:block">
                        <div className="h-1 w-full bg-white/5 rounded-full overflow-hidden">
                           <motion.div 
                              initial={{ width: 0 }}
                              animate={{ width: `${(nominee.voteCount / group.topThree[0].voteCount) * 100}%` }}
                              className={`h-full ${idx === 0 ? 'bg-[#D4AF37]' : 'bg-white/40'}`} 
                           />
                        </div>
                      </div>

                      <Zap size={14} className={idx === 0 ? "text-[#D4AF37]" : "text-white/10"} />
                    </div>
                  );
                })}
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Leaderboard;
